import { SimulationType } from '@core/models/simulation-metadata.model';
import { Threshold } from '@core/models/threshold.model';

export class ConstantHelper {
  public static textSizes: number[] = [8, 12, 16, 24, 40, 64, 96];

  public static fontOptions: { key: string; value: string }[] = [
    { key: 'Default', value: '' },
    { key: 'Arial', value: 'Arial, Helvetica, sans-serif, monospace' },
    { key: 'TimesNewRoman', value: 'Times New Roman, Times, serif, monospace' },
    { key: 'Georgia', value: 'Georgia, serif, monospace' },
    { key: 'Garamond', value: 'Garamond, serif, monospace' },
    { key: 'Courier New', value: 'Courier New, monospace' },
    { key: 'Verdana', value: 'Verdana, sans-serif, monospace' },
    { key: 'Brush Script MT', value: 'Brush Script MT, cursive, monospace' },
    { key: 'Copperplate', value: 'Copperplate, Papyrus, fantasy, monospace' },
    { key: 'Century Ghotic', value: 'centuryGhotic' }
  ];
  public static stepOptions: { key: string; value: number; range: number }[] = [
    { key: '3 minutes', value: 180, range: 172800 },
    { key: 'Heures', value: 3600, range: 604800 },
    { key: 'Jours', value: 86400, range: 5184000 },
    { key: 'Mois', value: 2592000, range: 63072000 }
  ];
  public static rangeOptions: { [key: number]: { key: string; value: number }[] } = {
    180: [
      { key: 'Dernière heure', value: 3600 },
      { key: 'Dernière journée', value: 86400 },
      { key: 'Dernières 48h', value: 172800 }
    ],
    3600: [
      { key: 'Dernière journée', value: 86400 },
      { key: 'Derniere semaine', value: 604800 },
      { key: 'Dernier mois', value: 2592000 }
      //{ key: 'Derniere 2 semaines', value: 1209600 },
    ],
    86400: [
      { key: 'Dernière semaine', value: 604800 },
      //{ key: 'Dernières 2 semaines', value: 1209600 },
      { key: 'Dernier mois', value: 2592000 },
      { key: 'Derniers 2 mois', value: 5184000 },
      { key: 'Dernière Année', value: 31536000 }
    ],
    2592000: [
      { key: 'Dernière Année', value: 31536000 },
      { key: 'Derniers 2 Ans', value: 63072000 }
    ]
  };

  public static nbColumnsOptions: { key: string; value: number }[] = [
    { key: '1', value: 1 },
    { key: '2', value: 2 },
    { key: '3', value: 3 },
    { key: '4', value: 4 },
    { key: '5', value: 5 },
    { key: '6', value: 6 }
  ];

  public static secondsToText(seconds: number): string {
    switch (seconds) {
      case 180:
        return '3 minutes';
      case 3600:
        return 'une heure';
      case 86400:
        return 'un jour';
      case 172800:
        return '2 jours';
      case 604800:
        return 'une semaine';
      case 2592000:
        return 'un mois';
      case 5184000:
        return '2 mois';
      case 31536000:
        return 'un an';
      case 63072000:
        return '2 ans';
      default:
        return '';
    }
  }

  public static simulationToType(simulation: SimulationType): string {
    switch (simulation) {
      case SimulationType.PRSIM:
        return 'Temps réel';
      case SimulationType.HREKO:
        return 'Horaire';
      case SimulationType.PSI:
        return 'Externe';
      default:
        return 'Autre';
    }
  }

  public static getInformationLimits(): { [key: string]: Threshold } {
    return {
      diameter: {
        id: 0,
        name: 'diameter',
        displayName: 'Diamètre',
        unit: 'Length',
        lowSystem: 0.005,
        highSystem: 2
      },
      length: {
        id: 0,
        name: 'length',
        displayName: 'Longueur',
        unit: 'Length',
        lowSystem: 1,
        highSystem: 100000
      },
      roughness: {
        id: 0,
        name: 'roughness',
        displayName: 'Rugosité moyenne',
        unit: 'Length',
        lowSystem: 0,
        highSystem: 0.002
      },
      alt: {
        id: 0,
        name: 'alt',
        displayName: 'Altitude',
        unit: 'Length',
        lowSystem: -10994,
        highSystem: 8848
      }
    };
  }
}
